import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import { v4 as uuidv4 } from 'uuid';
import { endpoints } from '@rossum/api-client';
import { Queue } from '@rossum/api-client/queues';
import { QueueRule } from '@rossum/api-client/schemas';
import { useApiClient } from '../../../lib/apiClient';
import { RULES_QUERY_KEY } from './rulesQueryKeys';

export const useDuplicateRule = () => {
  const api = useApiClient();
  const queryClient = useQueryClient();
  const intl = useIntl();

  return useMutation({
    onSuccess: (_data, variables) => {
      if (!variables.skipInvalidation) {
        queryClient.invalidateQueries([RULES_QUERY_KEY]);
      }
    },
    mutationFn: ({
      rule,
      queue,
      shouldUseSuffix,
    }: {
      rule: QueueRule;
      queue?: Queue;
      shouldUseSuffix?: boolean;
      skipInvalidation?: boolean;
    }) => {
      return api.request(
        endpoints.rules.create({
          name: shouldUseSuffix
            ? `${rule.name} (${intl.formatMessage({
                id: 'features.queueSettings.rules.list.duplicate.suffix',
              })})`
            : rule.name,
          description: rule.description,
          enabled: rule.enabled,
          triggerCondition: rule.triggerCondition,
          queues: queue ? [queue.url] : rule.queues,
          actions: rule.actions.map(action => ({
            ...action,
            id: uuidv4(),
          })),
        })
      );
    },
  });
};
